import { createSelector } from "reselect";
const selector = (state) => state.families;

export default createSelector([selector], (data) => data);